<template>
  <div>
    <el-row>
      <TableContainer
        CustomTableArticle
        :columns="containerTableColumns"
        :serverUrl="containerServerUrl"
        :baseUrl="containerBaseUrl"
        :tableToolConfig="tableToolConfig"
        ref="TableContainer"
      >
        <template v-slot:tools>
          <router-link :to="containerBaseUrl + '/add'">
            <el-button type="primary" icon="el-icon-circle-plus-outline">增加单位</el-button>
          </router-link>
        </template>

        <template v-slot:filter>
          <classunitSelect @onValueChanged="onStudyClassValueChanged"></classunitSelect>
          <!-- <selectTableFilterStatus
            @DoChange="DoChangeStatus"
            showReview
            showDraft
            ref="selectTableFilterStatusRef"
          ></selectTableFilterStatus>-->
        </template>

        <!--  -->
        <template v-slot:table__footer__info>单位列表</template>
      </TableContainer>

      <!-- <el-row>
          <p class="paragraph-content-small grey asset"><i class="el-icon-info"></i> 当前列表项的显示顺序，即是网站相关项目的显示顺序。</p>
      </el-row>-->
    </el-row>
  </div>
</template>




<script>
import { BaseVue } from "@/mixin/index";
import { deleteApi } from "@/api/core/table/table";
import { TableContainer } from "@/core/table/";
import classunitSelect from "@/views/module/classunit/components/classunitSelect.vue";

export default {
  name: "Classunit",
  
  mixins: [BaseVue],
  
  components: {
    TableContainer,
    classunitSelect
  },
  
  data() {
    return {
      // table 头
      containerTableColumns: [
        {
          prop: "title",
          label: "单位名",
          width: "330px"
        },
        {
          prop: "ptitle",
          label: "上级单位"
        }
      ],
      // 基础地址
      containerBaseUrl: "/standard/classunit",
      // api的基础地址
      containerServerUrl: "/api/manager/classunit",
      // table config 设置
      tableToolConfig: {
        canEdit: true,
        canRecover: true,
        canDelete: true,
        canDisable: true
      }
    };
  },
  
  methods: {
    // $emit 筛选内容改变
    onStudyClassValueChanged(pid) {
      (this.$refs.TableContainer).updatePid(pid);
    }
  },
  
  beforeMount() {
    // 组件挂载前的逻辑
  },
  
  mounted() {
    // 组件挂载后的逻辑
  }
};
</script>
<style scoped>
</style>